<template>
  <b-modal
    ref="addDataWidgetModal"
    hide-footer
    centered
    title="Create new data widget"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
        >
        <b-form-input
          type="text"
          v-model.trim="title"
          />
      </b-form-group>
      <b-form-group
        label="Data path:"
        >
        <b-form-input
          type="text"
          v-model.trim="dataPath"
          @keydown.native.32.prevent
          />
      </b-form-group>
      <div class="gridstackSize">
        <div class="gridstackSize__item">
          <b-form-group
            label="Gridstack width:"
            >
            <b-form-input
              v-model="gridstackWidth"
              type="number"
              min="1"
              max="24"
              @change="adjustGridstackWidth"
              />
          </b-form-group>
        </div>
        <div class="gridstackSize__item">
          <b-form-group
            label="Gridstack height:"
            >
            <b-form-input
              v-model="gridstackHeight"
              type="number"
              min="1"
              max="40"
              @change="adjustGridstackHeight"
              />
          </b-form-group>
        </div>
      </div>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  data () {
    return {
      title: '',
      gridstackWidth: 12,
      gridstackHeight: 10,
      dataPath: '/'
    }
  },
  computed: {
    ...mapState([
      'currentTab'
    ])
  },
  methods: {
    adjustGridstackWidth () {
      if (!+this.gridstackWidth) this.gridstackWidth = 1
      if (+this.gridstackWidth < 0) {
        this.gridstackWidth = 1
      }
      if (+this.gridstackWidth > 24) {
        this.gridstackWidth = 24
      }
    },
    adjustGridstackHeight () {
      if (!+this.gridstackHeight) this.gridstackHeight = 1
      if (+this.gridstackHeight < 0) {
        this.gridstackHeight = 1
      }
      if (+this.gridstackHeight > 40) {
        this.gridstackHeight = 40
      }
    },
    save () {
      let data = {}
      data.title = this.title
      data.path = this.dataPath
      data.w = this.gridstackWidth
      data.h = this.gridstackHeight
      data.tab = this.currentTab

      db.widgets.createDataWidget(data, (err) => {
        if (err) {
          this.$store.addError(err.message)
        } else {
          this.$refs.addDataWidgetModal.hide()
          this.title = ''
          this.path = '/'
          this.gridstackWidth = 12
          this.gridstackHeight = 10
        }
      })
    }
  },
  created () {
    eventBus.$on('showAddDataWidgetModal', () => {
      if (this.$refs.addDataWidgetModal) this.$refs.addDataWidgetModal.show()
    })
  },
  mounted () {
    if (this.$refs.addDataWidgetModal) {
      $(this.$refs.addDataWidgetModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.addDataWidgetModal) {
      $(this.$refs.addDataWidgetModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.gridstackSize {
  @include cf;
  &__item {
    @include span(6)
    &:first-child {
      padding-right: 10px;
    }
    &:last-child {
      padding-left: 20px;
    }
    @include breakpoint(max-width $screenSm) {
      @include span(12)
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddDataWidget.vue